/**
 * Pick the localization to show for a language.
 *
 * The backend returns one entry per culture code ('en-US', 'nl-NL', ...) while
 * the app works with a plain language ('en', 'nl'), so the match is made on the
 * language part of the culture code and is case insensitive. When nothing
 * matches, the first entry is used: a policy in the wrong language is still
 * better than a dead link.
 */
export const pickLocalization = (localizations, language) => {
	if (!Array.isArray(localizations)) {
		return undefined;
	}

	const languageCode = String(language || '').split('-')[0].toLowerCase();

	return localizations.find(localization => (
		String(localization?.cultureCode || '').split('-')[0].toLowerCase() === languageCode
	)) || localizations[0];
};

export default pickLocalization;
